export default "__VITE_ASSET__DK8cbrMB__"